<template>
  <div>

    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-user"></i> {{ (!showAccountNumber) ? 'Total ' +bankAccountNumbers.toLocaleString() + ' Accounts' : 'Bank Account'  }}</span>

      </div>
      <el-row :gutter="15" class="panel-group">
        <el-col :xs="24" :sm="12" :lg="6" class="card-panel-col" v-if="showAccountNumber">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-people">
              <svg-icon icon-class="peoples" class-name="card-panel-icon" />
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">Account</div>
              <!-- <count-to :start-val="0" :end-val="102400" :duration="2600" class="card-panel-num" /> -->
              <div class="card-panel-num">
                {{ bankAccountNumbers.toLocaleString() }}
              </div>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="24"
          :sm="12"
          :lg="6"
          class="card-panel-col"
          v-for="item in balances"
          :key="item.ledger_id"
        >
          <LedgerBalance
            :projectUID="item.project_uid"
            :customerUID="customerUID"
            :ledgerID="item.ledger_id"
            :apiMode="apiMode"
            :balance="preloadedBalance(item)"
          />
        </el-col>
        <el-col :xs="24" :sm="12" :lg="6" class="card-panel-col" v-if="loading && balances.length === 0">
          <div class="card-panel" v-loading="loading" style="height:110px"></div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import { getProjectBalance, getCustomerBalance } from "@/api/bank-account";
import LedgerBalance from "./ledger-balance";
import { mapGetters } from "vuex";
export default {
  components: {
    LedgerBalance,
  },
  computed:{
    ...mapGetters([
      "company_name",
      "company_uid",
    ]),
  },
  props: {
    projectUID: String,
    customerUID: String,
    bankAccountNumbers: Number,
    apiMode: String,
    showAccountNumber: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      loading: false,
      balances: [],
      balanceLedger: [],
    };
  },
  methods: {
    // Only batch items carry a balance; plain ledger-list items (fallback) and failed vendor calls load per card.
    preloadedBalance(item) {
      return item.balanceFormat !== undefined && !item.unavailable ? item : null
    },
    // All ledgers in one request (cached in store/balance for a short TTL).
    // Reload() from outside (after a transfer / topup / close) always forces a fresh read;
    // the current cards stay on screen until the new balances land.
    Reload(force = true) {
      const uid = this.apiMode === "customer" ? this.customerUID : this.projectUID
      this.loading = true;
      this.$store
        .dispatch("balance/fetch", { apiMode: this.apiMode, uid, force })
        .then((data) => {
          if (data) {
            this.balances = data
            return
          }
          // Batch endpoint failed (or the server is older): fall back to the ledger list,
          // each card then loads its own balance as before.
          const request = this.apiMode === "customer" ? getCustomerBalance(uid) : getProjectBalance(uid)
          return request.then(({ result, data }) => {
            if (result && data) {
              this.balances = data
            }
          })
        })
        .finally(() => {
          this.loading = false;
        });
    },
    gotoProject() {
      const route = this.$route;
      if (route.name === "ProjectCustomer") {
        window.location = `/project/${this.projectUID}?tab=project`;
      } else {
        this.$router.push(`/project/${this.projectUID}`);
      }
    },
  },
  created() {
    this.Reload(false)
  },
};
</script>

<style lang="scss" scoped>
.panel-group {
  margin-top: 18px;

  .card-panel-col {
    margin-bottom: 18px;
  }

  .card-panel {
    height: 108px;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
    border-color: rgba(0, 0, 0, 0.05);


    .icon-people {
      color: #40c9c6;
    }

    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 6px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;

    }

    .card-panel-icon {
      float: left;
      font-size: 48px;
    }

    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 10px;
      margin-left: 0px;

      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
        text-align: right;
      }

      .card-panel-num {
        font-size: 20px;
        text-align: right;
        margin-bottom: 7px;
      }
      .card-panel-acc {
        text-align: right;
        margin-bottom: 3px;
      }
      .card-panel-type {
        text-align: right;
      }
    }
  }
}

@media (max-width: 550px) {
  // .card-panel-description {
  //   display: none;
  // }

    .card-panel-icon-wrapper {
    float: none !important;
    width: 0px;
    height: 0px;
    padding: 0 !important;
    margin: 0 !important;

    .svg-icon {
      display: block;
      margin: 0px auto !important;
      float: none !important;
    }
  }
}
</style>
